
<template>
    <div>
        <!-- <div class="skeleton" v-if="skeleton"></div> -->
        <div v-if="filters">
            <div class="drop_block" v-show="!skeleton" tabindex="0" @focusout="openDropDown = false">
                <div class="drop_box for_desktop" @click="openDropDown = !openDropDown">
                    <div class="drop_name">
                        {{ label }}
                        <span v-if="label != 'sort' && currentValue.length > 0" class="active_count">({{ currentValue.length}})</span>
                    </div>
                    <div class="drop_arrow">
                        <SvgHeaderSvg :type="'down'" />
                    </div>
                </div>
                <div v-show="openDropDown" class="drop_item" :class="'drop_item_' + label">
                    <div class="title_close">
                        <div class="title">
                            <span>{{ label }} &nbsp;</span>
                            <span class="active_label for_desktop" v-if="label != 'style' && currentLabel">
                                <span>{{ currentLabel }}</span>
                            </span>
                            <div class="eclipse for_desktop" v-if="['style'].includes(label) && selectedOption.length">
                                <span class="active_label" v-for="select in selectedOption" :key="select.value">
                                    {{ select.label }}
                                </span>
                            </div>
                        </div>
                        <div class="close for_desktop" @click="openDropDown = false">
                            <SvgHeaderSvg :type="'close'" />
                        </div>
                    </div>
                    <ul class="mb-0" :class="{ 'full_ul': ['styles', 'sort', 'metals'].includes(label), 'half_ul': ['carats', 'shapes'].includes(label) }">
                        <li v-for="filter in filters" :key="filter.value"
                        :class="{ [filter.icon]: true, 'active': filter.active }"
                            @click="selectOption(filter.value)">
                            <div class="me-2 icon_box" v-if="label === 'shapes' && filter.value !== ''">
                                <SvgShapeSvg v-if="filter.active === false" :type="filter.icon" />
                                <SvgShapeSvg class="for_desktop" v-if="filter.active === true" :type="filter.icon + '_active_green' " />
                                <SvgShapeSvg class="for_mobile" v-if="filter.active === true" :type="filter.icon + '_active' " />
                            </div>
                            <!-- Styles Icon -->
                            <div class="me-2 icon_box" v-if="label === 'styles' && filter.icon !== ''">
                                <SvgStyleSvg v-if="filter.active === false" :type="filter.icon" />
                                <SvgStyleSvg class="for_desktop" v-if="filter.active === true" :type="filter.icon + '_active_green' " />
                                <SvgStyleSvg class="for_mobile" v-if="filter.active === true" :type="filter.icon + '_active' " />
                            </div>
                            <!-- Metals Icon -->
                            <div class="me-2 icon_box" v-if="label === 'metals' && filter.icon !== ''">
                                <div>
                                    <img v-if="filter.icon ==='white'" alt="white gold" width="50" height="50" src="~/assets/metals/white.png"/>
                                    <img v-if="filter.icon ==='yellow'" alt="yellow gold" width="50" height="50" src="~/assets/metals/yellow.png"/>
                                    <img v-if="filter.icon ==='rose'" alt="rose gold" width="50" height="50" src="~/assets/metals/rose.png"/>
                                </div>  
                                <!-- <SvgMetalSvg :type="filter.icon" /> -->
                            </div>
                            <span>{{ filter.label }}</span>
                        </li>
                    </ul>
                </div>
                
            </div>
        </div>
    </div>
</template>


<script setup>

const props = defineProps({
    filters: Array,
    label: String
});

const emit = defineEmits(['resetFilter', 'selectOption']);

const showOptions = ref(false);
const openDropDown = ref(false)
const { filters } = toRefs(props);

const currentLabel = computed(() => {
    let value = '';
    filters.value.find((cv) => {
        if (cv.active) {
            value = cv.label;
        }
    });
    return value;
});

const currentValue = computed(() => {
    return filters.value.filter(cv => cv.active)
});

const resetFilter = (filters) => {
    filters.forEach((item) => {
        item.active = false;
        showOptions.value = true
    });
    emit('resetFilter', filters);
};

const selectOption = (value) => {
    filters.value.forEach((item) => {
        item.active = item.value === value ? true : false;
    });
    showOptions.value = false;
    openDropDown.value=false
    emit('selectOption',value);
};

const selectedOption = computed(() => {
    return filters.value.filter(cv => cv.active);
});
</script>



<style scoped>
.skeleton {
    height: 42px;
    border-radius: 8px;
    background: #eaeaea;
    min-width: 85px;
}

.drop_box {
    display: flex;
    align-items: center;
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;
}

.drop_name {
    margin-right: 8px;
    font-size: 14px;
    text-transform: capitalize;
    font-weight: 400;
    color: #212529;
}

.drop_name .active_count {
    color: var(--green);
}

.drop_item {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    z-index: 99;
    min-width: 240px;
}

.drop_item.drop_item_shapes  {
    width: 315px;
}
.drop_item.drop_item_carats{
    width: 315px;
}

.title_close {
    padding: 15px 15px 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title_close .title {
    font-size: 14px;
    text-transform: capitalize;
    font-weight: 700;
    color: #000;
    display: flex;
    align-items: center;
}

.eclipse {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 140px;
}

.close {
    cursor: pointer;
}

ul {
    display: flex;
    flex-wrap: wrap;
    padding: 8px 8px 8px 8px;
}

ul.half_ul {
    justify-content: space-between;
  
}

ul li {
    list-style: none;
    min-height: 36px;
    min-width: 36px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 5px;
    cursor: pointer;
}

ul li.active {
    border: 1px solid var(--green) !important;
}

ul li.active span {
    color: var(--green);
    font-weight: 600;
}

ul.full_ul li {
    width: 100%;
    justify-content: flex-start;
    border: 1px solid #eaeaea;
    padding: 4px 12px;
}

ul.half_ul li {
    width: 46%;
    border: 1px solid #eaeaea;
    justify-content: flex-start;
    padding: 4px 12px;
}

/* ul li.white {
    background: #f5f5f5;
}

ul li.yellow {
    background: #f3dda1;
}

ul li.rose {
    background: #f3b089;
} */

.drop_block {
    position: relative;
}

ul li span {
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 400;
    color: #606060;
    display: block;
}

.active_label {
    color: var(--green);
}

@media(max-width: 767px) {
    .drop_item.drop_item_shapes {
        width: 100%;
    }

    ul.half_ul li{
        justify-content: center;
        min-height: 80px;
        align-items: center;
    }

    .drop_item.drop_item_carats{
        width: 100%;
    }
    ul.half_ul li {
        justify-content: center;
    }

    .title_close .title {
        text-transform: uppercase;
    }

    .drop_item {
        display: block !important;
        position: relative;
        left: 0;
        top: 0;
    }

    .drop_item {
        box-shadow: none;
    }

    .title_close {
        padding: 0;
    }

    ul {
        padding: 0;
    }

    ul li {
        margin: 0 10px 0 0;
    }

    .title {
        margin-bottom: 10px;
        display: block;
        width: 100%;
    }

    .drop_block {
        margin-bottom: 20px;
    }

    ul {
        align-items: stretch;
        border: 0;
        display: flex !important;
        overflow-x: scroll;
        overflow-y: hidden;
        padding: 0 0 8px;
        position: relative;
        white-space: nowrap;
        flex-wrap: nowrap;
    }

    ul li {
        align-items: flex-start;
        border: 1px solid #ccc;
        border-radius: 4px;
        justify-content: center;
        margin-right: 10px;
        min-width: 95px;
        /* padding: 10px; */
        text-align: center;
    }

    ul li span {
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500;
        white-space: break-spaces;
    }

    ul.full_ul li, ul.half_ul li, ul li {
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
    }

    .icon_box {
        margin-right: 0 !important;
    }

    ul li.active {
        background: var(--green);
    }

    ul li.active span {
        color: #fff;
    }

    ul.full_ul li, 
    ul.half_ul li,
    ul li{
        padding: 14px 12px;
        
    }
}
</style>